// @tennis-matches/services/trainerstunden/people
// Service for managing trainerstunden people

import {
  loadClubPeople,
  mergeClubPeopleWithMissingIds,
  createClubPerson,
  updateClubPerson,
  deleteClubPerson,
} from "../masterdata/people.js";

/**
 * Load all people for the current user
 * @returns {Promise<{ok: boolean, data?: Array, error?: any}>}
 */
export async function loadPeople() {
  return await loadClubPeople();
}

export async function mergePeopleWithMissingIds(people, extraIds) {
  return await mergeClubPeopleWithMissingIds(people, extraIds);
}

/**
 * Create a new person
 * @param {Object} person - Person data
 * @returns {Promise<{ok: boolean, data?: Object, error?: any}>}
 */
export async function createPerson(person) {
  return await createClubPerson(person);
}

/**
 * Update a person
 * @param {string} id - Person ID
 * @param {Object} updates - Fields to update
 * @returns {Promise<{ok: boolean, data?: Object, error?: any}>}
 */
export async function updatePerson(id, updates) {
  return await updateClubPerson(id, updates);
}

/**
 * Delete a person
 * @param {string} id - Person ID
 * @returns {Promise<{ok: boolean, error?: any}>}
 */
export async function deletePerson(id) {
  return await deleteClubPerson(id);
}
